export default __webpack_public_path__ + "static/media/stethoscope.3bb0fc76.png";